import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import proptypes from 'prop-types';
import { WelcomeCardProvider, PacDrawerProvider, SweepstakesDrawerProvider } from '../contexts';

const { string, elementType, object, oneOfType } = proptypes;

const AllProviders = ({ children }) => {
  return (
    <QueryProvider cacheKey="loyalty-benefits-cacheKey">
      <WelcomeCardProvider>
        <PacDrawerProvider>
          <SweepstakesDrawerProvider>
            {children}
          </SweepstakesDrawerProvider>
        </PacDrawerProvider>
      </WelcomeCardProvider>
    </QueryProvider>
  );
};

const LoyaltyWelcomeCardProviders = ({ children, componentName }) => {
  return (
    <QueryProvider cacheKey="loyalty-benefits-cacheKey">
      <WelcomeCardProvider componentName={componentName}>
        {children}
      </WelcomeCardProvider>
    </QueryProvider>
  );
};

const SweepstakesDrawerProviders = ({ children }) => {
  return (
    <QueryProvider cacheKey="loyalty-benefits-cacheKey">
      <SweepstakesDrawerProvider>
        {children}
      </SweepstakesDrawerProvider>
    </QueryProvider>
  );
};

export const ComponentProviders = ({ children, componentName }) => {
  let ChildProviders = <AllProviders>{children}</AllProviders>;
  switch (componentName) {
  case 'LoyaltyWelcomeCard':
    ChildProviders = <LoyaltyWelcomeCardProviders>{children}</LoyaltyWelcomeCardProviders>;
    break;
  case 'SweepstakesDrawers':
    ChildProviders = <SweepstakesDrawerProviders>{children}</SweepstakesDrawerProviders>;
    break;
  case 'LoyaltyBanner':
    ChildProviders = <LoyaltyWelcomeCardProviders>{children}</LoyaltyWelcomeCardProviders>;
    break;
  case 'OffersCard':
    ChildProviders = <LoyaltyWelcomeCardProviders componentName="OffersCard">{children}</LoyaltyWelcomeCardProviders>;
    break;
  default:
    break;
  }
  return ChildProviders;
};

ComponentProviders.propTypes = {
  children: oneOfType([
    elementType,
    object
  ]),
  componentName: string,
};

ComponentProviders.defaultProps = {
  children: AllProviders,
  componentName: '',
};